import { Datatype, isPlainDatatype } from '../../../datatype/Datatype.ts';
import { createConditionOperator } from '../IConditionOperator.ts';

export const ConditionOperatorNotDefinedType = createConditionOperator({
  code: 'notDefined',
  label: 'non definito',
  description: 'Non definito',
  args: [],
  allowsField: field =>
    isPlainDatatype(field.type) || field.type === Datatype.File,
  compare(value: any) {
    return value == null || (typeof value === 'string' && value.trim() === '');
  },
});
